import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { paymentAPI } from '../services/api';
import './PaymentSuccess.css';

export default function PaymentSuccess() {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('order_id');
  const [status, setStatus] = useState('checking'); // checking | success | pending | failed
  const [planInfo, setPlanInfo] = useState(null);
  const navigate = useNavigate();
  const pollRef = useRef(null);
  const attemptsRef = useRef(0);

  useEffect(() => {
    if (!orderId) { setStatus('failed'); return; }

    const check = async () => {
      try {
        const res = await paymentAPI.getOrderStatus(orderId);
        const { order_status, local_status, plan, billing_cycle } = res.data;

        if (local_status === 'PAID' || order_status === 'PAID') {
          clearInterval(pollRef.current);
          setPlanInfo({ plan, billing_cycle });
          setStatus('success');
          return;
        }

        if (order_status === 'EXPIRED' || order_status === 'CANCELLED' || attemptsRef.current > 10) {
          clearInterval(pollRef.current);
          setStatus(order_status === 'PAID' ? 'success' : 'failed');
          return;
        }

        attemptsRef.current += 1;
        setStatus('pending');
      } catch {
        clearInterval(pollRef.current);
        setStatus('failed');
      }
    };

    check();
    pollRef.current = setInterval(check, 3000);
    return () => clearInterval(pollRef.current);
  }, [orderId]);

  const planLabel = planInfo?.plan
    ? planInfo.plan.charAt(0).toUpperCase() + planInfo.plan.slice(1)
    : '';

  return (
    <div className="pay-result">
      {status === 'checking' || status === 'pending' ? (
        <div className="pay-result__card pay-result__card--pending">
          <div className="pay-result__spinner" />
          <h2 className="pay-result__title">Confirming your payment…</h2>
          <p className="pay-result__desc">Please wait while we verify your transaction. This usually takes a few seconds.</p>
        </div>
      ) : status === 'success' ? (
        <div className="pay-result__card pay-result__card--success">
          <div className="pay-result__icon pay-result__icon--success">✓</div>
          <h2 className="pay-result__title">Payment Successful!</h2>
          <p className="pay-result__desc">
            You're now on the <strong>{planLabel}</strong> plan.
            {planInfo?.billing_cycle === 'annual' ? ' Billed annually.' : ' Renews in 30 days.'}
          </p>
          <button className="pay-result__btn" onClick={() => navigate('/dashboard')}>
            Go to Dashboard
          </button>
        </div>
      ) : (
        <div className="pay-result__card pay-result__card--failed">
          <div className="pay-result__icon pay-result__icon--failed">✕</div>
          <h2 className="pay-result__title">Payment Not Confirmed</h2>
          <p className="pay-result__desc">
            Your payment could not be confirmed. If money was deducted, it will be refunded automatically within 5–7 business days.
          </p>
          <div className="pay-result__actions">
            <button className="pay-result__btn pay-result__btn--outline" onClick={() => navigate('/pricing')}>
              Try Again
            </button>
            <button className="pay-result__btn" onClick={() => navigate('/dashboard')}>
              Back to Dashboard
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
